import type { DataGridProps, GridColDef, GridGetRowsParams, GridPaginationModel, GridValidRowModel } from '@mui/x-data-grid';
import { AoaTable } from '../../atoms/table/Table';

export interface AoaFileTableProps<T extends GridValidRowModel = any> {
  /**
   * The column structure to display the data
   */
  columns: GridColDef<T>[];
  /**
   * The TableData object to be displayed in the table
   */
  data: T[];
  /**
   * Data-qa tag for E2E test purposes
   */
  'data-qa'?: string;
  /**
   * Overwrite a safe selection of the {@link DataGrid} properties
   */
  dataGridOverridableProps?: Pick<DataGridProps<T>, 'getRowId' | 'ignoreDiacritics'>;
  /**
   * Sets the initial query options to retain query details after opening a page and returning to the table
   */
  initialQueryOptions?: GridPaginationModel & Omit<GridGetRowsParams, 'end' | 'paginationModel' | 'start'>;
}

export function AoaFileTable<T extends object = any>({
  data,
  columns,
  initialQueryOptions,
  dataGridOverridableProps,
  'data-qa': dataQa
}: Readonly<AoaFileTableProps<T>>) {
  return (
    <AoaTable<T>
      columns={columns}
      data={{
        rows: data ?? [],
        rowCount: data?.length ?? 0
      }}
      data-qa={dataQa}
      dataGridOverridableProps={dataGridOverridableProps}
      initialQueryOptions={initialQueryOptions}
      mode='client'
    />
  );
}
